import * as parts from './parts'

export interface CallsColors {
  ListView: parts.CallsListViewColors
  DetailView: parts.LegacyCallDetailsViewColors
}

export const callsColors: CallsColors = {
  ListView: parts.callsListViewColors,
  DetailView: parts.legacyCallDetailsViewColors,
}
